import React from "react";
import "../StartApplication.scss";
import LostDataModal from "../../SharedComponents/LostDataModal";
import { putCCBInfo } from "../../../api/makeAPIRequest";
import { FORM_ID } from "../../../constants/Forms";
import "../../../assets/stylesheets/StartApplication/IndividualBroker/CharacterCreditBonding.scss";
import { UtagTracking } from "../../../utils/utag-tracking";
import { CONTRACT_TYPE_DESCRIPTIONS } from "../../../constants/Contract";
import NavigationButtons from "../../SharedComponents/NavigationButtons";
import { isNullUndefinedOrEmpty } from "../../../common/Functions";

class CCBForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.initialState();
    this.handleLawsuitChange = this.handleLawsuitChange.bind(this);
    this.handleCrimeChange = this.handleCrimeChange.bind(this);
    this.handleSuspendedChange = this.handleSuspendedChange.bind(this);
    this.handleBankruptcyChange = this.handleBankruptcyChange.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.handleShowBackModal = this.handleShowBackModal.bind(this);
    this.handleCloseBackModal = this.handleCloseBackModal.bind(this);
    this.handleBackClick = this.handleBackClick.bind(this);
  }

  async componentDidMount() {
    var lawsuitYN = "";
    var lawsuit = "";
    var failedYN = "";
    var failed = "";
    var licsuspendYN = "";
    var licsuspend = "";
    var convictedYN = "";
    var convicted = "";
    var candidateID = "";

    try {
      const result = this.props.ccbData;

      lawsuitYN = result.invlawsuit === null ? "" : result.invlawsuit;
      lawsuit = result.invlawsuitdesc === null ? "" : result.invlawsuitdesc;
      failedYN = result.failedbusiness === null ? "" : result.failedbusiness;
      failed =
        result.failedbusinessdesc === null ? "" : result.failedbusinessdesc;
      licsuspendYN = result.licsuspend === null ? "" : result.licsuspend;
      licsuspend = result.licsuspenddesc === null ? "" : result.licsuspenddesc;
      convictedYN = result.convictcrime === null ? "" : result.convictcrime;
      convicted =
        result.convictcrimedesc === null ? "" : result.convictcrimedesc;
      candidateID = result.candidateid === null ? "" : result.candidateid;

      if (lawsuitYN === true) {
        lawsuitYN = "Y";
      }
      if (lawsuitYN === false) {
        lawsuitYN = "N";
      }
      if (failedYN === true) {
        failedYN = "Y";
      }
      if (failedYN === false) {
        failedYN = "N";
      }
      if (licsuspendYN === true) {
        licsuspendYN = "Y";
      }
      if (licsuspendYN === false) {
        licsuspendYN = "N";
      }
      if (convictedYN === true) {
        convictedYN = "Y";
      }
      if (convictedYN === false) {
        convictedYN = "N";
      }
      await this.setState({
        lawsuit: lawsuitYN,
        crime: convictedYN,
        suspended: licsuspendYN,
        bankruptcy: failedYN,
        lawsuit_text: lawsuit,
        crime_text: convicted,
        suspended_text: licsuspend,
        bankruptcy_text: failed,
        candidate_id: candidateID,
        is_form_complete: true,
      });
      UtagTracking.sendPageNameView(
        "charactercreditbondingform",
        this.props.candidateId,
        this.props.agencynumber,
        this.props.contracttypeid
      );

      this.props.isFormComplete(
        "CCBCompleteInd",
        this.props.ccbData.convictcrime !== null &&
          this.props.ccbData.failedbusiness !== null &&
          this.props.ccbData.invlawsuit !== null &&
          this.props.ccbData.licsuspend !== null
      );
    } catch (err) {
      console.log(err);
    }
  }

  initialState() {
    return {
      lawsuit: "",
      lawsuit_error: false,
      crime: "",
      crime_error: false,
      suspended: "",
      suspended_error: false,
      bankruptcy: "",
      bankruptcy_error: false,
      lawsuit_text: "",
      lawsuit_text_error: false,
      lawsuit_text_max_error: false,
      lawsuit_text_error_text: false,
      crime_text: "",
      crime_text_error: false,
      crime_text_max_error: false,
      crime_text_error_text: false,
      suspended_text: "",
      suspended_text_error: false,
      suspended_text_max_error: false,
      suspended_text_error_text: false,
      bankruptcy_text: "",
      bankruptcy_text_error: false,
      bankruptcy_text_max_error: false,
      bankruptcy_text_error_text: false,
      candidate_id: "",
      showBackModal: false,
      formHasChanged: false,
      is_form_complete: false,
      isLoading: false,
    };
  }

  async handleLawsuitChange(event) {
    this.props.isFormComplete("CCBCompleteInd", false);
    this.props.hasCurrentFormChanged(true);
    await this.setState({
      lawsuit: event.target.value,
      lawsuit_error: false,
      lawsuit_text: event.target.value === "Y" ? this.state.lawsuit_text : "",
      lawsuit_text_error: false,
      lawsuit_text_max_error: false,
      lawsuit_text_error_text: "",
      is_form_complete: false,
      formHasChanged: true,
    });
  }

  async handleCrimeChange(event) {
    this.props.isFormComplete("CCBCompleteInd", false);
    this.props.hasCurrentFormChanged(true);
    await this.setState({
      crime: event.target.value,
      crime_error: false,
      crime_text: event.target.value === "Y" ? this.state.crime_text : "",
      crime_text_error: false,
      crime_text_max_error: false,
      crime_text_error_text: "",
      is_form_complete: false,
      formHasChanged: true,
    });
  }

  async handleSuspendedChange(event) {
    this.props.isFormComplete("CCBCompleteInd", false);
    this.props.hasCurrentFormChanged(true);
    await this.setState({
      suspended: event.target.value,
      suspended_error: false,
      suspended_text:
        event.target.value === "Y" ? this.state.suspended_text : "",
      suspended_text_error: false,
      suspended_text_max_error: false,
      suspended_text_error_text: "",
      is_form_complete: false,
      formHasChanged: true,
    });
  }

  async handleBankruptcyChange(event) {
    this.props.isFormComplete("CCBCompleteInd", false);
    this.props.hasCurrentFormChanged(true);
    await this.setState({
      bankruptcy: event.target.value,
      bankruptcy_error: false,
      bankruptcy_text:
        event.target.value === "Y" ? this.state.bankruptcy_text : "",
      bankruptcy_text_error: false,
      bankruptcy_text_max_error: false,
      bankruptcy_text_error_text: "",
      is_form_complete: false,
      formHasChanged: true,
    });
  }

  async handleNext() {
    this.setState({
      isLoading: true,
    });

    var allFilled = true;
    if (
      isNullUndefinedOrEmpty(this.state.lawsuit) ||
      (this.state.lawsuit === "Y" &&
        isNullUndefinedOrEmpty(this.state.lawsuit_text))
    ) {
      this.setState({
        lawsuit_error: isNullUndefinedOrEmpty(this.state.lawsuit),
        ...(this.state.lawsuit === "Y" && {
          lawsuit_text_error: isNullUndefinedOrEmpty(this.state.lawsuit_text),
          lawsuit_text_error_text: "Please enter an explanation",
        }),
      });
      allFilled = false;
    }
    if (
      isNullUndefinedOrEmpty(this.state.crime) ||
      (this.state.crime === "Y" &&
        isNullUndefinedOrEmpty(this.state.crime_text))
    ) {
      this.setState({
        crime_error: isNullUndefinedOrEmpty(this.state.crime),
        ...(this.state.crime === "Y" && {
          crime_text_error: isNullUndefinedOrEmpty(this.state.crime_text),
          crime_text_error_text: "Please enter an explanation",
        }),
      });
      allFilled = false;
    }
    if (
      isNullUndefinedOrEmpty(this.state.suspended) ||
      (this.state.suspended === "Y" &&
        isNullUndefinedOrEmpty(this.state.suspended_text))
    ) {
      this.setState({
        suspended_error: isNullUndefinedOrEmpty(this.state.suspended),
        ...(this.state.suspended === "Y" && {
          suspended_text_error: isNullUndefinedOrEmpty(
            this.state.suspended_text
          ),
          suspended_text_error_text: "Please enter an explanation",
        }),
      });
      allFilled = false;
    }
    if (
      isNullUndefinedOrEmpty(this.state.bankruptcy) ||
      (this.state.bankruptcy === "Y" &&
        isNullUndefinedOrEmpty(this.state.bankruptcy_text))
    ) {
      this.setState({
        bankruptcy_error: isNullUndefinedOrEmpty(this.state.bankruptcy),
        ...(this.state.bankruptcy === "Y" && {
          bankruptcy_text_error: isNullUndefinedOrEmpty(
            this.state.bankruptcy_text
          ),
          bankruptcy_text_error_text: "Please enter an explanation",
        }),
      });
      allFilled = false;
    }

    await this.setState({ is_form_complete: allFilled });
    if (allFilled) {
      this.props.saveCharCreditBonding("characterCreditBonding", {
        ...this.props.ccbData,
        convictcrime: this.state.crime === "Y",
        convictcrimedesc: this.state.crime_text,
        failedbusiness: this.state.bankruptcy === "Y",
        failedbusinessdesc: this.state.bankruptcy_text,
        invlawsuit: this.state.lawsuit === "Y",
        invlawsuitdesc: this.state.lawsuit_text,
        licsuspend: this.state.suspended === "Y",
        licsuspenddesc: this.state.suspended_text,
      });
      if (this.state.is_form_complete === true) {
        let data = {
          candidateid: this.state.candidate_id,
          invlawsuit: this.state.lawsuit,
          invlawsuitexp: this.state.lawsuit_text,
          convcrime: this.state.crime,
          convcrimeexp: this.state.crime_text,
          proflic: this.state.suspended,
          proflicexp: this.state.suspended_text,
          failedbus: this.state.bankruptcy,
          failedbusexp: this.state.bankruptcy_text,
        };
        putCCBInfo(this.props.subId, data);
        this.props.hasCurrentFormChanged(false);
        this.setState({ formHasChanged: false });
        this.props.toggleForm(FORM_ID.ERRORS_OMISSIONS);
      }
    }
    this.setState({
      isLoading: false,
    });
    this.props.isFormComplete("CCBCompleteInd", allFilled);
  }

  handleChange(event) {
    this.setState({
      [event.target.id]: event.target.value,
      [event.target.id + "_max_error"]: event.target.value.length === 500,
      ...(event.target.value.length === 500
        ? {
            [event.target.id + "_error_text"]:
              "You have reached the maximum characters allowed",
          }
        : {
            [event.target.id + "_error_text"]: "Please enter an explanation",
          }),
      is_form_complete: false,
      formHasChanged: true,
    });
    this.props.isFormComplete("CCBCompleteInd", false);
    this.props.hasCurrentFormChanged(true);
  }
  onKeyPress(event) {
    if (this.state[event.target.id].length >= 500) {
      this.setState({
        [event.target.id + "_max_error"]: true,
        [event.target.id + "_error_text"]:
          "You have reached the maximum characters allowed",
      });
    }
  }

  onBlur(event) {
    this.setState({
      [event.target.id + "_error"]: event.target.value.trim(" ").length < 1,
      [event.target.id + "_error_text"]:
        event.target.value.trim(" ").length < 1
          ? "Please enter an explanation"
          : "",
      [event.target.id + "_max_error"]: false,
    });
  }

  handleCloseBackModal() {
    this.setState({ showBackModal: false });
  }

  handleBackClick() {
    const { convictcrime, failedbusiness, invlawsuit, licsuspend } =
      this.props.ccbData;
    this.props.isFormComplete(
      "CCBCompleteInd",
      convictcrime !== null &&
        failedbusiness !== null &&
        invlawsuit !== null &&
        licsuspend !== null
    );
    this.setState({ formHasChanged: false });
    this.handleCloseBackModal();
    this.props.toggleForm(FORM_ID.BROKER_DEALER);
  }

  handleShowBackModal() {
    //show back modal if anything on the form has changed
    if (this.state.formHasChanged) {
      this.setState({ showBackModal: true });
    } else {
      //this.props.toggleForm(6);
      this.props.toggleForm(FORM_ID.BROKER_DEALER);
    }
  }

  render() {
    return (
      <div id="charactercreditbonding">
        {(this.props.contractType === CONTRACT_TYPE_DESCRIPTIONS.BROKER_CORP ||
          this.props.contractType ===
            CONTRACT_TYPE_DESCRIPTIONS.MEMBER_CORP) && (
          <div className="row">
            <div className="col-md-12">
              <div className="eyebrow">
                <strong>Member of Corporation</strong>
              </div>
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-md-12">
            <h1 id="ccb_header">Character, Credit, and Bonding</h1>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <span id="ccb_required_text" className="required-field-text">
              * = Required Field
            </span>
          </div>
        </div>
        <div id="ccb_question1" className="row">
          <div className="col-md-12">
            <h3 id="ccbQuestion1Header">
              Are you now or have you in the past been directly or indirectly
              involved in a lawsuit since you have been in the business of
              insurance?*
            </h3>
            <div className="custom-control custom-radio">
              <input
                type="radio"
                id="lawsuit_yes"
                name="lawsuit"
                className={
                  this.state.lawsuit_error
                    ? "custom-control-input is-invalid"
                    : "custom-control-input"
                }
                checked={this.state.lawsuit === "Y"}
                value="Y"
                onChange={this.handleLawsuitChange}
              />
              <label
                htmlFor="lawsuit_yes"
                className="custom-control-label"
                id="lawsuitYesLabel"
              >
                Yes
              </label>
            </div>

            <div className="custom-control custom-radio">
              <input
                type="radio"
                id="lawsuit_no"
                name="lawsuit"
                className={
                  this.state.lawsuit_error
                    ? "custom-control-input is-invalid"
                    : "custom-control-input"
                }
                checked={this.state.lawsuit === "N"}
                value="N"
                onChange={this.handleLawsuitChange}
              />
              <label
                htmlFor="lawsuit_no"
                className="custom-control-label"
                id="lawsuitNoLabel"
              >
                No
              </label>
            </div>
            {this.state.lawsuit_error && (
              <div id="lawsuit_error" className="invalid-feedback show">
                Please choose a response
              </div>
            )}
            {this.state.lawsuit === "Y" && (
              <div id="lawsuitreason" className={"invalid-feedback show"}>
                <div className="row">
                  <div className="col-md-12">
                    <label
                      id="ccb_question1_explain"
                      className="authQuestions"
                      htmlFor="lawsuit_text"
                    >
                      Please explain your involvement in a lawsuit relative to
                      insurance practice.*
                    </label>
                    <textarea
                      rows="5"
                      id="lawsuit_text"
                      className={
                        this.state.lawsuit_text_error ||
                        this.state.lawsuit_text_max_error
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      maxLength={500}
                      autoComplete="new-password"
                      value={this.state.lawsuit_text}
                      onBlur={this.onBlur}
                      onChange={this.handleChange}
                      onKeyDown={this.onKeyPress}
                    ></textarea>
                    {(this.state.lawsuit_text_error ||
                      this.state.lawsuit_text_max_error) && (
                      <div
                        id="lawsuit_text_error"
                        className="invalid-feedback show"
                      >
                        {this.state.lawsuit_text_error_text}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div id="ccb_question2" className="row">
          <div className="col-md-12">
            <h3 id="ccbQuestion2Header">
              Have you ever been convicted of any crime (felony or
              misdemeanor)?*
            </h3>
            <div className="custom-control custom-radio">
              <input
                type="radio"
                id="crime_yes"
                name="crime"
                className={
                  this.state?.crime_error
                    ? "custom-control-input is-invalid"
                    : "custom-control-input"
                }
                checked={this.state.crime === "Y"}
                value="Y"
                onChange={this.handleCrimeChange}
              />
              <label
                htmlFor="crime_yes"
                className="custom-control-label"
                id="crimeYesLabels"
              >
                Yes
              </label>
            </div>
            <div className="custom-control custom-radio">
              <input
                type="radio"
                id="crime_no"
                name="crime"
                className={
                  this.state?.crime_error
                    ? "custom-control-input is-invalid"
                    : "custom-control-input"
                }
                checked={this.state.crime === "N"}
                value="N"
                onChange={this.handleCrimeChange}
              />
              <label
                htmlFor="crime_no"
                className="custom-control-label"
                id="crimeNoLabel"
              >
                No
              </label>
            </div>
            {this.state.crime_error && (
              <div id="crime_error" className="invalid-feedback show">
                Please choose a response
              </div>
            )}
            {this.state.crime === "Y" && (
              <div id="crimereason">
                <div className="row">
                  <div className="col-md-12">
                    <label
                      id="ccb_question2_explain"
                      className="authQuestions"
                      htmlFor="crime_text"
                    >
                      Please explain the crime (felony or misdemeanor) of which
                      you have been convicted.*
                    </label>
                    <textarea
                      rows="5"
                      id="crime_text"
                      className={
                        this.state.crime_text_error ||
                        this.state.crime_text_max_error
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      maxLength={500}
                      autoComplete="new-password"
                      value={this.state.crime_text}
                      onBlur={this.onBlur}
                      onChange={this.handleChange}
                      onKeyDown={this.onKeyPress}
                    ></textarea>
                    {(this.state.crime_text_error ||
                      this.state.crime_text_max_error) && (
                      <div
                        id="crime_text_error"
                        className="invalid-feedback show"
                      >
                        {this.state.crime_text_error_text}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div id="ccb_question3" className="row">
          <div className="col-md-12">
            <h3 id="ccbQuestion3Header">
              Have you ever had a professional license suspended, revoked,
              cancelled, or had your employment or contract 'terminated for
              cause'?*
            </h3>
            <div className="custom-control custom-radio">
              <input
                type="radio"
                id="suspended_yes"
                name="suspended"
                className={
                  this.state.suspended_error
                    ? "custom-control-input is-invalid"
                    : "custom-control-input"
                }
                checked={this.state.suspended === "Y"}
                value="Y"
                onChange={this.handleSuspendedChange}
              />
              <label
                htmlFor="suspended_yes"
                className="custom-control-label"
                id="suspendedYesLabel"
              >
                Yes
              </label>
            </div>
            <div className="custom-control custom-radio">
              <input
                type="radio"
                id="suspended_no"
                name="suspended"
                className={
                  this.state.suspended_error
                    ? "custom-control-input is-invalid"
                    : "custom-control-input"
                }
                checked={this.state.suspended === "N"}
                value="N"
                onChange={this.handleSuspendedChange}
              />
              <label
                htmlFor="suspended_no"
                className="custom-control-label"
                id="suspendedNoLabel"
              >
                No
              </label>
            </div>
            {this.state.suspended_error && (
              <div id="suspended_error" className="invalid-feedback show">
                Please choose a response
              </div>
            )}
            {this.state.suspended === "Y" && (
              <div id="suspendedreason">
                <div className="row">
                  <div className="col-md-12">
                    <label
                      id="ccb_question3_explain"
                      className="authQuestions"
                      htmlFor="suspended_text"
                    >
                      Please explain why your professional license was
                      suspended, revoked, cancelled, or why your employment or
                      contract was 'terminated for cause'.*
                    </label>
                    <textarea
                      rows="5"
                      id="suspended_text"
                      className={
                        this.state.suspended_text_error ||
                        this.state.suspended_text_max_error
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      maxLength={500}
                      autoComplete="new-password"
                      value={this.state.suspended_text}
                      onBlur={this.onBlur}
                      onChange={this.handleChange}
                      onKeyDown={this.onKeyPress}
                    ></textarea>
                    {(this.state.suspended_text_error ||
                      this.state.suspended_text_max_error) && (
                      <div
                        id="suspended_text_error"
                        className="invalid-feedback show"
                      >
                        {this.state.suspended_text_error_text}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div id="ccb_question4" className="row">
          <div className="col-md-12">
            <h3 id="ccbQuestion4Header">
              Have you ever failed in business, declared bankruptcy, compromised
              with creditors, or had any liens or judgments against you?*
            </h3>
            <div className="custom-control custom-radio">
              <input
                type="radio"
                id="bankruptcy_yes"
                name="bankruptcy"
                className={
                  this.state.bankruptcy_error
                    ? "custom-control-input is-invalid"
                    : "custom-control-input"
                }
                checked={this.state.bankruptcy === "Y"}
                value="Y"
                onChange={this.handleBankruptcyChange}
              />
              <label
                htmlFor="bankruptcy_yes"
                className="custom-control-label"
                id="bankruptcyYesLabel"
              >
                Yes
              </label>
            </div>
            <div className="custom-control custom-radio">
              <input
                type="radio"
                id="bankruptcy_no"
                name="bankruptcy"
                className={
                  this.state.bankruptcy_error
                    ? "custom-control-input is-invalid"
                    : "custom-control-input"
                }
                checked={this.state.bankruptcy === "N"}
                value="N"
                onChange={this.handleBankruptcyChange}
              />
              <label
                htmlFor="bankruptcy_no"
                className="custom-control-label"
                id="bankruptcyNoLabel"
              >
                No
              </label>
            </div>
            {this.state.bankruptcy_error && (
              <div id="bankruptcy_error" className="invalid-feedback show">
                Please choose a response
              </div>
            )}
            {this.state.bankruptcy === "Y" && (
              <div id="bankruptcyreason">
                <div className="row">
                  <div className="col-md-12">
                    <label className="authQuestions" htmlFor="bankruptcy_text">
                      Please explain if you have ever failed in business,
                      declared bankruptcy, compromised with creditors, or had
                      any liens or judgments against you.*
                    </label>
                    <textarea
                      rows="5"
                      id="bankruptcy_text"
                      className={
                        this.state.bankruptcy_text_error ||
                        this.state.bankruptcy_text_max_error
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      maxLength={500}
                      autoComplete="new-password"
                      value={this.state.bankruptcy_text}
                      onBlur={this.onBlur}
                      onChange={this.handleChange}
                      onKeyDown={this.onKeyPress}
                    ></textarea>
                    {(this.state.bankruptcy_text_error ||
                      this.state.bankruptcy_text_max_error) && (
                      <div
                        id="bankruptcy_text_error"
                        className="invalid-feedback show"
                      >
                        {this.state.bankruptcy_text_error_text}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <NavigationButtons
          onBack={this.handleShowBackModal}
          onNext={this.handleNext}
          isLoading={this.state.isLoading}
          isDisabled={this.state.isLoading}
          nxtbtnid={"ccb_next"}
          bckbtnid={"ccb_back"}
        />
        <LostDataModal
          isOpen={this.state.showBackModal}
          handleClose={this.handleCloseBackModal}
          handleProceed={this.handleBackClick}
        />
      </div>
    );
  }
}

export default CCBForm;
